import { message } from "antd";

type MessageType = "success" | "error" | "warning";

const FLASH_MESSAGES = "flash-messages";

interface Entity {
  type: MessageType;
  message: string;
}

const getAllFlashMessages = (): Entity[] => {
  const items = sessionStorage.getItem(FLASH_MESSAGES) || "";

  try {
    return JSON.parse(items) as Entity[];
  } catch (e) {
    return [] as Entity[];
  }
};

export const addMessage = (message: string, type: MessageType = "success") => {
  const messages = getAllFlashMessages();

  messages.push({
    type,
    message,
  });

  sessionStorage.setItem(FLASH_MESSAGES, JSON.stringify(messages));
};

export const callMessages = (duration?: number): void => {
  const messages = getAllFlashMessages();

  messages.forEach((entity) => {
    message.open({
      content: entity.message,
      type: entity.type,
      duration: duration || 1.5,
    });
  });

  sessionStorage.removeItem(FLASH_MESSAGES);
};

export const getMessages = (): Entity[] => getAllFlashMessages();
